import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { Path } from 'config/portal'
import { AgreementsMapping } from 'config/products'
import { RecordTypes } from 'flatfile-config'
import { BD_TRANSANCTION_INFO } from '../../../config/bdTransactionInfoKeys'
import { convertNumber } from 'utils'
import { PlanConfirmationForm } from '../forms'
import { selectors } from '../reducer'
import { selectors as globalSelectors } from '../../reducer'
import * as actions from '../actions'
import * as apiActions from 'api-actions'
import createPlanConfirmationView, {
  createGetActiveBenefitAboveThresholdParticipants,
} from '../../products/views/createPlanConfirmationView'

const getDistributionAmount = (participant) =>
  convertNumber(participant[BD_TRANSANCTION_INFO.AMOUNT])

const SharedPlanConfirmationView = createPlanConfirmationView({
  PlanConfirmationFormComponent: PlanConfirmationForm,
  agreementsMapping: AgreementsMapping.BD_PLAN_MATCHING,
  nextPath: '/benefit-distributions/review-and-submit-participant-data',
  uploadFilePath: '/benefit-distributions/upload-file',
  allParticipantsRemovedPath: Path.SERVICES_AGREEMENTS,
  recordType: RecordTypes.ARO_PARTICIPANT,
  getActiveBenefitAboveThresholdParticipants:
    createGetActiveBenefitAboveThresholdParticipants(getDistributionAmount),
  selectors,
  actions,
  fetchAgreementsAction: apiActions.fetchCompletedServicesAgreements,
  agreementsSelectorFn: (state) => selectors.completedServicesAgreements(state),
})

function PlanConfirmationView(props) {
  return <SharedPlanConfirmationView {...props} />
}

function mapStateToProps(state) {
  return {
    currentUser: globalSelectors.currentUser(state),
  }
}

export default compose(connect(mapStateToProps))(PlanConfirmationView)
